import { Box } from "@mui/system";
import success from "../../Images/Svg/invoiceinfo/invoice-successful.svg";
import rejected from "../../Images/Svg/invoiceinfo/invoice-rejected.svg";
import expired from "../../Images/Svg/invoiceinfo/invoice-expired.svg";
import { Typography } from "@mui/material";
import CommonButton from "../../CommonComponents/CommonButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getJPInvoiceDetails } from "../../Services/approval.service";
import ClearIcon from "@mui/icons-material/Clear";

const invoiceStatus = {
  approved: {
    icon: success,
    status: "Approved",
    color: "#5CA15D",
    message: (
      <Typography sx={{ fontSize: "1.7rem", lineHeight: "1.3" }}>
        Invoice has been <br /> <b>Successfully Approved</b>
      </Typography>
    ),
  },
  rejected: {
    icon: rejected,
    status: "rejected",
    color: "#DE490A",
    message: (
      <Typography sx={{ fontSize: "1.7rem", lineHeight: "1.3" }}>
        Invoice has been <br />
        <b>Successfully Rejected</b>
      </Typography>
    ),
  },
  expired: {
    icon: expired,
    status: "OOPS!",
    color: "#0471AB",
    message: (
      <Typography sx={{ fontSize: "1.7rem" }}>
        The link has <br /> <b>expired</b>
      </Typography>
    ),
  },
  invalid: {
    icon: expired,
    status: "OOPS!",
    color: "#0471AB",
    message: (
      <Typography sx={{ fontSize: "1.7rem" }}>
        <b>Invalid Link</b>
      </Typography>
    ),
  },
  error: {
    icon: expired,
    status: "Error!",
    color: "#0471AB",
    message: (
      <Typography sx={{ fontSize: "1.7rem" }}>
        <b>Invoice not found.</b>
      </Typography>
    ),
  },
};

const InvoiceInfo = () => {
  const [approvalStatus, setIsApprovalStatus] = useState("");
  const [queryParams] = useSearchParams();
  const navigate = useNavigate();
  const onClickHandler = () => {
    navigate("/", { replace: true });
  };
  useEffect(() => {
    const token = queryParams.get("token");
    if (token) {
      getJPInvoiceDetails(encodeURIComponent(token))
        .then((res) => {
          console.log(res);
          setIsApprovalStatus(res?.status || "invalid");
        })
        .catch((err) => {
          if (err.status === 404) {
            setIsApprovalStatus("error");
          }
        });
    }
    return () => {
      setIsApprovalStatus("invalid");
    };
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        height: "100vh",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {approvalStatus ? (
          <>
            {approvalStatus === "error" ? (
              <ClearIcon
                sx={{ alignSelf: "center", fontSize: "48px", color: "red" }}
              />
            ) : (
              <img
                src={invoiceStatus[approvalStatus].icon}
                width={"79px"}
                height={"79px"}
                style={{ textAlign: "center", margin: "0 auto" }}
              />
            )}
            <Typography
              style={{
                color: invoiceStatus[approvalStatus].color,
                margin: "14px 0px",
                textAlign: "center",
                fontWeight: "700",
                fontSize: "2.2rem",
              }}
            >
              {invoiceStatus[approvalStatus].status?.toUpperCase()}
            </Typography>
            <Box sx={{ display: "block", textAlign: "center" }}>
              {invoiceStatus[approvalStatus].message}
              <Box
                sx={{
                  width: "40%",
                  margin: "16px auto",
                  textAlign: "center",
                }}
              >
                <CommonButton
                  filledButton
                  label="OK"
                  sx={{ padding: "inherit 20px" }}
                  onClick={onClickHandler}
                />
              </Box>
            </Box>
          </>
        ) : (
          <Typography sx={{ fontWeight: 500, fontSize: "2rem" }}>
            Loading...
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default InvoiceInfo;
